export default "__VITE_ASSET__CRESQ2wM__"